import { render } from "./MiTable.vue?vue&type=template&id=e8c1bcc4&scoped=true"
import script from "./MiTable.vue?vue&type=script&lang=js"
export * from "./MiTable.vue?vue&type=script&lang=js"

import "./MiTable.vue?vue&type=style&index=0&id=e8c1bcc4&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c1bcc4"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QIcon});
